import{__require as r}from"./shared.js";import{__require as e}from"./uid.js";var i,u;function t(){if(u)return i;u=1;var t=r(),n=e(),o=t("keys");return i=function(r){return o[r]||(o[r]=n(r))}}export{t as __require};
//# sourceMappingURL=shared-key.js.map
